interface TagProps {
  label: string;
  onDelete?: () => void;
}

export const Tag: React.FC<TagProps> = ({label, onDelete}) => {
  return (
    <div style={tagStyle}>
      <span>{label}</span>
      {onDelete && (
        <button onClick={onDelete} style={buttonStyle}>
          &times;
        </button>
      )}
    </div>
  );
};

const tagStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '4px 12px',
  backgroundColor: '#e0e7ff',
  color: '#4338ca',
  borderRadius: '16px',
  fontSize: '14px',
  fontWeight: 500,
  gap: '8px',
};

const buttonStyle: React.CSSProperties = {
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  fontSize: '16px',
  lineHeight: 1,
  color: '#4338ca',
  padding: 0,
};
